import { getAdMarketCountryCode } from 'owa-cookie-targeting/lib/utils/getAdMarketCountryCode';
import { isGdprAdMarket } from 'owa-cookie-targeting/lib/utils/isGdprAdMarket';

export function isEUEmailAdsPolicyMarket() {
    const countryCode = getAdMarketCountryCode();

    // Exclude GB from EU from the GDPR country. If it turns out GB needs to apply the policy,
    // we can use the same check as isGdprAdMarket
    if (countryCode === 'GB') {
        return false;
    }

    return isGdprAdMarket();
}
